import type { ItemTextDto } from "@/models/dto/questionDto";

export class CertificateModel {
  label: string = "";
  details: string = "";
  expiryDate: string = "";
  auditDate: string = "";
  auditResult: ItemTextDto = { id: "", text: "" };
  checked: boolean = false;

  constructor(certificateName: string, details: string) {
    this.label = certificateName;
    this.details = details;
  }

  setChecked(newChecked: boolean): void {
    this.checked = newChecked;
    if (!this.checked) {
      this.expiryDate = "";
      this.expiryDate = "";
      this.auditDate = "";
      this.auditResult.id = "";
      this.auditResult.text = "";
    }
  }

  toAnswerModel(): AnswerCertificateModel {
    return new AnswerCertificateModel(
      this.label,
      this.expiryDate,
      this.auditDate,
      this.auditResult.id,
      this.checked
    );
  }
}

export class AnswerCertificateModel {
  label: string;
  expiryDate: string;
  auditDate: string;
  auditResult: string;
  checked: boolean;

  constructor(
    label: string,
    expiryDate: string,
    auditDate: string,
    auditResult: string,
    checked: boolean
  ) {
    this.label = label;
    this.expiryDate = expiryDate;
    this.auditDate = auditDate;
    this.auditResult = auditResult;
    this.checked = checked;
  }
}
